import React, { useEffect, useState } from "react";
import { fetchWebImagesByCategory, WEB_IMAGE_BASE } from "../../services/webImageService";
import "./webImagesSection.css";

const WebImagesSection = ({ category, className = "" }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWebImagesByCategory(category).then((res) => {
      if (res.status === 200) setImages(res.data);
      setLoading(false);
    });
  }, [category]);

  if (loading) {
    return (
      <div className={`wi-section-skeletons ${className}`}>
        {[1, 2, 3].map((i) => <div key={i} className="wi-skeleton" />)}
      </div>
    );
  }

  if (images.length === 0) return null;

  return (
    <div className={`wi-section ${className}`}>
      {images.map((img) => (
        <img
          key={img.id}
          src={`${WEB_IMAGE_BASE}${img.imageUrl}`}
          alt={img.name}
          className="wi-section-img"
        />
      ))}
    </div>
  );
};

export default WebImagesSection;
